import styled from '@emotion/styled'
import useConfig from 'modules/config/state/use-config'
import CheckboxField from 'modules/ui/molecules/FormComponents/CheckboxField'
import { SyntheticEvent } from 'react'
import { DEFAULT_THEME_COLORS } from 'tokens/theme'
import { CLASSY_TERMS_URL } from 'utils/constants/misc'
import { useTranslation, Trans } from 'next-i18next'

const stopPropagation = (e: SyntheticEvent) => e.stopPropagation()

const Wrapper = styled.div({
  a: {
    textDecoration: 'underline',
    color: DEFAULT_THEME_COLORS['--theme-color__text-general'],
  },
  '.checkbox-container': {
    alignItems: 'flex-start', // keeps the checkbox at the top of the long block of text
  },
})

const OrderOptInFields = () => {
  const config = useConfig()
  const { t, i18n } = useTranslation()
  const language = i18n.language

  return (
    <>
      {config.optIn.isEnabled && (
        // TODO - i18n: Determine if 'config.optIn.wording' requires translation or is user-provided
        <CheckboxField id="optIn" dataId="contact-opt-in-checkbox">
          {config.optIn.wording}
        </CheckboxField>
      )}

      {config.optInSms.isEnabled && (
        <Wrapper>
          <CheckboxField id="optInSms" dataId="contact-opt-in-sms-checkbox">
            {config.organization.name && (
              <span>
                <Trans
                  i18nKey="orderOptInFields.smsOptIn.description"
                  values={{ orgName: config.organization.name }}
                  components={{
                    terms: (
                      <a
                        href={
                          CLASSY_TERMS_URL[language as keyof typeof CLASSY_TERMS_URL] ||
                          CLASSY_TERMS_URL.default
                        }
                        onClick={stopPropagation}
                        target="_blank"
                      >
                        Terms
                      </a>
                    ),
                    privacy: (
                      <a
                        href={config.organization?.privacy_policy_url ?? '#'}
                        onClick={stopPropagation}
                        target="_blank"
                      >
                        Privacy Policy
                      </a>
                    ),
                  }}
                  defaultValue="By checking this box you agree to receive periodic automated and nonautomated text messages, including marketing messages, from or on behalf of {{ orgName }} at the phone number above. Consent is not required. <terms>Terms</terms> and <privacy>Privacy Policy</privacy> apply. Msg and data rates may apply."
                />
              </span>
            )}
          </CheckboxField>
        </Wrapper>
      )}
    </>
  )
}

export default OrderOptInFields
